import axios, { AxiosResponse } from 'axios'
import * as Sentry from '@sentry/browser'

export interface ApiResponseData {
  config: {}
  data: any
  headers: {}
  request: XMLHttpRequest
  status: number
  statusText: string
  meta: string
}
export const errorHandring = (err: Error, msg: string) => {
  console.error(err)
  alert(`データが正常に取得できませんでした。${msg}`)
}

export default {
  async postToApiGateway(
    api: string,
    postDataObject: object,
    timeOut: null | number = null
  ): Promise<AxiosResponse<ApiResponseData>> {
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    const _idToken = document.cookie.replace(
      /(?:(?:^|.*;\s*)kumasan_idToken\s*=\s*([^;]*).*$)|^.*$/,
      '$1'
    )
    const _accessIdToken = document.cookie.replace(
      /(?:(?:^|.*;\s*)kumasan_accessToken\s*=\s*([^;]*).*$)|^.*$/,
      '$1'
    )

    const headers = {
      Authorization: _idToken,
      authorizationaccesstoken: _accessIdToken,
    }
    // <AxiosResponse<T>> ってな感じ。
    const url = process.env.VUE_APP_API_URL + api

    if (timeOut) {
      setTimeout(() => {
        // cancel the request (the message parameter is optional)
        source.cancel('OperationCancel')
      }, timeOut)
    }

    return axios
      .post(url, JSON.stringify(postDataObject), {
        headers: headers,
        cancelToken: source.token,
      })
      .then((res: any) => {
        return res
      })
      .catch(err => {
        console.error(err)
        Sentry.withScope(scope => {
          scope.setTag('api', api)
          scope.setExtra('postData', postDataObject)
          Sentry.captureException(err)
        })

        if (err.message === 'OperationCancel') {
          return {
            data: {
              meta: 'F-9999',
            },
          }
        } else {
          errorHandring(err, 'ダッシュボードに戻ります。')
          // 離脱防止アラート初期化
          window.onbeforeunload = () => undefined
          location.href = '/dashboard'
        }
      })
  },
}


/**
 * =================== REST API ===================
 */
// CookieからIDトークンを取得して、認証ヘッダーを作成する
const getAuthHeaders = (): { Authorization: string } => {
  const idToken = document.cookie.replace(
    /(?:(?:^|.*;\s*)kumasan_idToken\s*=\s*([^;]*).*$)|^.*$/,
    '$1'
  )
  return { Authorization: idToken }
}

const getRestApiUrl = (endpoint: string): string =>
  process.env.VUE_APP_API_URL + endpoint

// エラーハンドリングの共通処理
const handleApiError = (
  restEndpoint: string,
  extra: object,
  error: any
): Promise<never> => {
  Sentry.withScope(scope => {
    scope.setTag('restEndpoint', restEndpoint)
    Object.entries(extra).forEach(([key, value]) => {
      scope.setExtra(key, value)
    })
    Sentry.captureException(error)
  })
  return Promise.reject(error)
}

// GETリクエスト
export const getToRestApiGateway = async (
  restEndpoint: string,
  params: object
): Promise<AxiosResponse> => {
  const cancelTokenSource = axios.CancelToken.source()
  const headers = getAuthHeaders()
  const restApiUrl = getRestApiUrl(restEndpoint)

  try {
    return await axios.get(restApiUrl, {
      headers,
      params,
      cancelToken: cancelTokenSource.token,
    })
  } catch (error) {
    return handleApiError(restEndpoint, { params }, error)
  }
}

// POSTリクエスト
export const postToRestApiGateway = async (
  restEndpoint: string,
  data: object
): Promise<AxiosResponse> => {
  const cancelTokenSource = axios.CancelToken.source()
  const headers = getAuthHeaders()
  const restApiUrl = getRestApiUrl(restEndpoint)

  try {
    return await axios.post(restApiUrl, data, {
      headers,
      cancelToken: cancelTokenSource.token,
    })
  } catch (error) {
    return handleApiError(restEndpoint, { data }, error)
  }
}

// PUTリクエスト
export const putToRestApiGateway = async (
  restEndpoint: string,
  data: object
): Promise<AxiosResponse> => {
  const cancelTokenSource = axios.CancelToken.source()
  const headers = getAuthHeaders()
  const restApiUrl = getRestApiUrl(restEndpoint)

  try {
    return await axios.put(restApiUrl, data, {
      headers,
      cancelToken: cancelTokenSource.token,
    })
  } catch (error) {
    return handleApiError(restEndpoint, { data }, error)
  }
}

// DELETEリクエスト
export const deleteToRestApiGateway = async (
  restEndpoint: string,
  params: object
): Promise<AxiosResponse> => {
  const cancelTokenSource = axios.CancelToken.source()
  const headers = getAuthHeaders()
  const restApiUrl = getRestApiUrl(restEndpoint)

  try {
    return await axios.delete(restApiUrl, {
      headers,
      params,
      cancelToken: cancelTokenSource.token,
    })
  } catch (error) {
    return handleApiError(restEndpoint, { params }, error)
  }
}
